/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'checkmark': {
    width: 16,
    height: 16,
    viewBox: '0 0 12 12',
    data: '<g _fill="none" fill-rule="evenodd"><path pid="0" d="M4.451 9.796l-.02.021L0 5.387 1.289 4.1 4.45 7.26 10.71 1 12 2.289 4.472 9.817l-.02-.02z" _fill="#30A63D"/></g>'
  }
})
